import { ConfirmDialog } from '@amelio/ui-library';

import type { User } from '@/types/directory/User';

import { useAmelioTranslations } from '@/hooks';
import { formatNameList } from '@/utils/nameList';
import { getFullName } from '@/utils/user';

interface LockedAdditionsConfirmDialogProps {
    /** The respondents about to be invited to a launched anonymous 360; the dialog is closed while there are none. */
    reviewers: User[];
    onAnswer: (confirmed: boolean) => void;
}

/** Names the respondents about to be invited and reminds that, once invited, they can no longer be removed. */
export const LockedAdditionsConfirmDialog = ({
    reviewers,
    onAnswer,
}: LockedAdditionsConfirmDialogProps) => {
    const { t, i18n } = useAmelioTranslations();

    const values = {
        count: reviewers.length,
        names: formatNameList(
            reviewers.map((reviewer) => getFullName(reviewer)),
            i18n.language,
        ),
    };

    return (
        <ConfirmDialog
            isOpen={reviewers.length > 0}
            title={t('evaluation360AssignReviewers.confirmLockedAdditions.title', values)}
            message={t('evaluation360AssignReviewers.confirmLockedAdditions.message', values)}
            confirmLabel={t('evaluation360AssignReviewers.confirmLockedAdditions.confirm')}
            cancelLabel={t('common.cancel')}
            onConfirm={() => onAnswer(true)}
            onCancel={() => onAnswer(false)}
        />
    );
};
